import _ from 'underscore';

import bmcCheckboxTemplate from './bmc-flag-template.pug';
import { DropdownView } from './dropdown-view';

export class BMCTemplateFactory {
  constructor({ i18n }) {
    this.i18n = i18n;
  }

  generateDropdownViewForForm(isForVNext) {
    const i18nLoader = this.i18n;

    return class DropdownViewWithI8N extends DropdownView {
      initialize({ observable, field }) {
        super.initialize({
          observable,
          field,
          i18n: i18nLoader,
          isForVNext,
        });
      }
    };
  }

  generateBmcCheckboxTemplateFunctionForForm(hasStore) {
    return options => (
      bmcCheckboxTemplate(_.extend({
        hasStore,
      }, options))
    );
  }
}
